// Common building blocks shared across endpoint schemas.
import { z } from 'zod'

export const Uuid = z.string().uuid()

// Most success responses follow `{ success: true, data: <T> }`.
export const SuccessEnvelope = (DataSchema) =>
  z.object({
    success: z.literal(true),
    data: DataSchema,
  })

// Error envelope used by the AppError + Sequelize-normaliser middleware.
export const ErrorEnvelope = z.object({
  status: z.literal('error'),
  message: z.string(),
})

export const UserPublic = z.object({
  id: Uuid,
  email: z.string(),
  full_name: z.string().nullable().optional(),
  user_type: z.string().nullable().optional(),
  auth_provider: z.string().nullable().optional(),
  is_email_verified: z.boolean().optional(),
  profile_complete: z.boolean().optional(),
  created_at: z.union([z.string(), z.date()]).optional(),
})
